import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { ConditionalTextHeadingFieldModel } from '../../../models/conditional-text-heading-field.model';


@Component({
    selector: 'agpr-conditional-text-heading-field',
    templateUrl: './conditional-text-heading-field.component.html',
    styleUrls: ['./conditional-text-heading-field.component.scss'],
    standalone: false
})
export class ConditionalTextHeadingFieldComponent extends AbstractFormFieldComponent implements OnChanges {
    @Input() declare field: ConditionalTextHeadingFieldModel;

    showHeading: boolean = true;

    ngOnChanges(changes: SimpleChanges): void {
        const displayCondition = this.field.displayCondition.bind(this);
        this.showHeading = displayCondition();
    }
}
